/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilitiesDTO } from './capabilities-dto';
import { UserCompactDTO } from './user-compact-dto';


export interface TipoPraticaOperatoreAssegnazioneDTO { 
    user_id?: string;
    user?: UserCompactDTO;
    capabilities?: CapabilitiesDTO;
    version?: number;
    created_at?: string;
    updated_at?: string;
}

